import React, { Component } from "react";
import styled from "styled-components";
import { FaDolly, FaRedo, FaDollarSign } from "react-icons/fa";
export default class Services extends Component {
  state = {
    services: [
      {
        id: 1,
        icon: <FaDolly />,
        title: "free shipping",
        text:
          " Lorem ipsum dolor sit amet consectetur adipisicing elit. Quos, accusamus.",
      },
      {
        id: 2,
        icon: <FaRedo />,
        title: "30 days return policy",
        text:
          " Lorem ipsum dolor sit amet consectetur adipisicing elit. Quos, accusamus.",
      },
      {
        id: 3,
        icon: <FaDollarSign />,
        title: "secured payment",
        text:
          " Lorem ipsum dolor sit amet consectetur adipisicing elit. Quos, accusamus.",
      },
    ],
  };
  render() {
    return (
      <ServicesWrapper className="py-5">
        <div className="container">
          <div className="row">
            {this.state.services.map((item) => {
              return (
                <div
                  className="boxx col-10 mx-auto col-sm-6 col-md-4 text-center my-3"
                  key={item.id}
                >
                  <div className="inner">
                    <div className="icon">{item.icon}</div>
                    <h3>{item.title}</h3>
                    <p>{item.text}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </ServicesWrapper>
    );
  }
}

const ServicesWrapper = styled.section`
  background: var(--darkGrey);
  height: 430px;
  .inner {
    padding: 30px;
    text-align: center;
    position: relative;
    box-shadow: 0 0 25px var(--mainGrey);
    &:before {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      width: 0;
      box-sizing: border-box;
      height: 0;
      border-bottom: 3px solid transparent;
      border-left: 3px solid transparent;
      transition: all 0.8s ease;
    }
    &:after {
      content: "";
      position: absolute;
      right: 0;
      top: 0;
      width: 0;
      box-sizing: border-box;
      height: 0;
      border-top: 3px solid transparent;
      border-right: 3px solid transparent;
      transition: all 0.8s ease;
    }
    .icon {
      font-size: 50px;
      color: var(--mainBlack);
      transition: color 0.8s ease;
    }
    h3 {
      font-size: 20px;
      font-weight: bold;
      color: var(--mainBlack);
      margin: 20px 0;
    }
    p {
      font-size: 18px;
      color: var(--mainBlack);
      line-height: 24px;
    }
  }
  .boxx {
    &:hover {
      .inner {
        &:after {
          border-color: var(--mainColor);
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .boxx {
    &:hover {
      .inner {
        &:before {
          border-color: var(--mainColor);
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .boxx {
    &:hover {
      .inner {
        .icon {
          color: var(--mainGrey);
        }
      }
    }
  }
  @media (max-width: 767px) {
    .boxx {
      width: 100%;
    }
  }
`;
